import templateAdmin from '../../../../Template/config/components/adminView'

export default {
    ...templateAdmin
}


// WEBPACK FOOTER //
// ./src/app/configuration/FidelityV2/config/components/adminView/index.js